import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";

import { Router } from "@angular/router";

import { TransferService } from "../../services/transfer.service";


@Component({
  selector: "app-modal-transfer",
  templateUrl: "./modal-transfer.component.html",
  styleUrls: ["./modal-transfer.component.scss"],
})
export class ModalTransferComponent implements OnInit {
  repositories: any[] = [];
  selectedRepository: any = null;
  projectId: number;
  submitted: boolean = true;
  // submitted = true;

  constructor(
    private activeModal: NgbActiveModal,
    private transferService: TransferService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getRepositories();
  }

  getRepositories() {
    this.transferService.getRepositories().subscribe(
      (data: any) => {
        if (
          data &&
          data.data &&
          Array.isArray(data.data) &&
          data.data.length > 0
        ) {
          this.repositories = data.data;
        } else {
          console.error("Dados inválidos recebidos do servidor:", data);
          this.repositories = [];
        }
      },
      (error) => {
        console.error("Erro ao obter os dados:", error);
        this.repositories = [];
      }
    );
  }

  toSend() {
    if (!this.selectedRepository) {
      this.toastr.error('Nenhum repositório selecionado.', 'Erro');
      return;
    }

    this.transferService
      .transferProject(this.projectId, this.selectedRepository)
      .subscribe(
        (response) => {
          this.toastr.success('Projeto transferido com sucesso.');
          this.closeModal();
          this.router.navigate(["/"]);

        },
        (error) => {
          this.toastr.error('Erro ao transferir o projeto.', error);
        }
      );
  }

  closeModal() {
    this.activeModal.close();
  }

  dismissModal() {
    this.activeModal.dismiss();
  }


}
